import Em from 'ember';
const HtmlEscaper = {};
const escapeExpression = Em.Handlebars.Utils.escapeExpression;
HtmlEscaper.escape = function (html) {
  return escapeExpression(html);
};
HtmlEscaper.unescape = function (html) {
  if (!html) {
    return html;
  }
  html = html.replace(/&amp;/g, '&');
  html = html.replace(/&lt;/g, '<');
  html = html.replace(/&gt;/g, '>');
  html = html.replace(/&quot;/g, '"');
  html = html.replace(/&#x27;/g, "'");
  html = html.replace(/&#x60;/g, '`');
  html = html.replace(/&#x3D;/g, '=');
  return html;
};
export default HtmlEscaper;